<template>
  <div class="hechengpooldata-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Tabs>
        <Form :model="goods"
              :label-width="80"
              ref="goodsValidate"
              :rules="goodsValidate">
          <Row>
            <Col span="8">
            <FormItem label="选择材料"
                      label-position="top">
              <Select v-model="goods.good_id"
                      clearable
                      filterable
                      placeholder="选择材料">
                <Option v-for="item in goodtablelist"
                        :value="item.good_id"
                        :key="item.good_id">{{item.good_title}}</Option>
              </Select>
            </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="25">
            <FormItem label="封面图">
              <upload-thumb v-model="goods.thumb"
                            ref="uploadthumb"
                            :defaultList="thumblist"
                            :autoCropWidth="150"
                            :autoCropHeight="150"
                            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:150*150,大小不超过2M'"></upload-thumb>
            </FormItem>
            </Col>
          </Row>
        </Form>
      </Tabs>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="creategoods('goodsValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../../common/thumb";

export default {
  name: "hechengpooldata-list",
  data () {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传封面图"));
      } else {
        callback();
      }
    };

    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      goodtablelist: [],
      attrList: [],
      goods: {},
      isable: true,
      loading: true,
      dataloading: true,
      thumblist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "标题",
          key: "data_name",
          minWidth: 200
        },
        {
          title: "封面图",
          key: "thumb",
          fixed: "left",
          render: (h, params) => {
            const zUrl = "https://images.weserv.nl/?url=";
            let thumbImg =
              params.row.thumb.indexOf("https") > -1
                ? zUrl + params.row.thumb
                : params.row.thumb;
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: thumbImg
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      goodsValidate: {
        // thumb: [{ required: true, validator: validateThumb, trigger: "change" }]
      },
      id: 0
    };
  },
  created: function () {
    this.getTableList();
    this.getGoodList();
  },
  components: {
    UploadThumb
  },

  methods: {
    getTableList: function () {
      this.$api.hechengpooldata
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
            // 同步筛选条件
            this.renderTable();
          }
        });
      return;
    },
    //获取材料
    getGoodList: function () {
      this.$api.data
        .list({
          page: 1,
          size: 10
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.goodtablelist = res.result.list;
          }
        });
      return;
    },
    // 展开添加
    showModel () {
      this.title = "添加材料";
      this.goods = {
        thumb: ""
      };
      this.isable = true;
      this.thumblist = new Array();
      this.getGoodList();

      this.$refs["goodsValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (id) {
      this.title = "编辑材料";
      this.thumblist = new Array();
      this.$refs["goodsValidate"].resetFields();
      this.showModalStatus = true;
      this.$api.hechengpooldata.detail({ id: id }).then(res => {
        this.goods = res.result; //disabled
        // this.goods.good_id.attr = this.goods.good_attr_id.toString();
        if (this.goods.thumb != null && this.goods.thumb != "") {
          this.thumblist.push({
            name: this.goods.thumb,
            url: this.goods.thumb,
            status: "finished"
          });
        }
      });
    },
    // 添加
    creategoods (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.goods.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.goods.thumb = null;
          }
          if (
            this.goods.id == null ||
            this.goods.id == 0 ||
            this.goods.id == undefined
          ) {
            //新建材料
            this.$api.hechengpooldata.create(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = false;
              }
              this.goods.id = null;
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          } else {
            //编辑材料
            this.$api.hechengpooldata.edit(this.goods).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = false;
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.hechengpooldata.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList(1);
            }
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable();
    },
    // 筛选
    renderTable: function (name) {
      if (name == 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.hechengpooldata.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>

